import { useState } from "react";
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  IColumn,
  ICommandBarItemProps,
  Icon,
  PrimaryButton,
  SharedColors,
  TooltipHost,
  mergeStyleSets,
} from "@fluentui/react";
import { useComboModeloEquipos } from "../../../../hooks/combosHooks/useComboModeloEquipos";
import { TableSelectRow } from "../../../../components/Table/TableSelectRow";
import { ITablaPersonaEquipo } from "../../../../Interfaces/IListaVerificacion";
import { useBoolean } from "@fluentui/react-hooks";
import { IModeloEquipoDelete } from "../../../../Interfaces/DispositivoAsignado/IDispositivoAsignado";
import { IconStyles } from "../../../../utils/helpers/stylesHelper";
import { MensajeBar } from "../../../../components/generic/ManejoResponseMessage/MessageBar";
import IdicadorProgress from "../../../../components/generic/IndicadorProgress";
import IconHelper from "../../../../utils/helpers/iconHelper";
import { PanelAsignacionModeloEquipo } from "./PanelAsignacionModeloEquipo";
import { FooterTable } from "../../../../components/Table/FooterTable";
import { PanelAgregarEquipoModelo } from "./PanelAgregarEquipoModelo";
interface IAsignacionEquiposPorPersona {
  personaId: string | undefined;
}
const classNames = mergeStyleSets({
  iconFont: {
    padding: 0,
    fontSize: "16px",
    marginRight: 5,
  },
});

export const AsignacionEquiposPorPersona = (
  props: IAsignacionEquiposPorPersona
) => {
  const [objEliminarModeleEquipom, setObjEliminarModeloEquipo] =
    useState<IModeloEquipoDelete>(null!);

  const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);

  const [personaId, setPersonaId] = useState("");

  const {
    onClickNext,
    onClickPrevius,
    paginacion,
    loading,
    itemsEquipoAsignados,
    isSendEliminar,
    responseDelete,
    ocultarMensajeResponse,
    deleteModeloEquipo,
    getDataPersonaEquipo,
  } = useComboModeloEquipos(props.personaId, isOpen);

  const [hideDelteEquipo, { toggle: toggleHideDeleteEquipo }] =
    useBoolean(true);

  const leftButtom: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_ADD,
      text: "Agregar Modelo",
      onClick: () => {
        openPanel();
      },
    },
  ];

  const columnTableEquipos: IColumn[] = [
    /*  {
       key: "column1",
       name: "Tipo de Equipo",
       fieldName: "tipoEquipo",
       minWidth: 100,
       maxWidth: 200,
       isResizable: true,
     }, */
    {
      key: "column2",
      name: "Modelo de Equipo",
      fieldName: "nombre",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "column3",
      name: "Fecha Asignación",
      fieldName: "created",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "column4",
      name: "Opciones",
      fieldName: "equipoModeloId",
      minWidth: 50,
      maxWidth: 50,
      isResizable: true,
      onRender: (item: ITablaPersonaEquipo) => (
        <>
          <TooltipHost content="Eliminar">
            <Icon
              style={{ color: SharedColors.red10, cursor: "pointer" }}
              iconName="Trash"
              className={classNames.iconFont}
              onClick={() => {
                toggleHideDeleteEquipo();
                if (props.personaId) {
                  setObjEliminarModeloEquipo({
                    equipoModeloId: item.equipoModeloId,
                    personaId: props.personaId,
                  });
                }
              }}
            />
          </TooltipHost>
        </>
      ),
    },
  ];



  return (
    <>
      {/* <pre>{JSON.stringify("--------Exist Data Props---", null, 2)}</pre>
      <pre>{JSON.stringify(props.personaId, null, 2)}</pre> */}
      <div className="ms-Grid">
        <div className="ms-Grid-row">
          <MensajeBar
            response={responseDelete}
            ocultar={() => {
              ocultarMensajeResponse();
            }}
          />
          <div className="ms-Grid-col ms-sm12 ms-lg12">

            <TableSelectRow
              loading={loading}
              leftBar={leftButtom}
              columns={columnTableEquipos}
              items={itemsEquipoAsignados}
            />
            <div style={{ margin: "10px", height: "50px" }}>
              <FooterTable
                onClickNext={onClickNext}
                onClickPrevius={onClickPrevius}
                TotalData={paginacion?.total}
                PaginaActual={paginacion?.page}
                TotalPagina={paginacion?.pages}
              />
            </div>
          </div>
        </div>
      </div>

      {/* <PanelAsignacionModeloEquipo
        personaId={props.personaId}
        isOpen={isOpen}
        onDismiss={dismissPanel}
        onRenderTable={getDataPersonaEquipo}
      /> */}

      <PanelAgregarEquipoModelo
        personaId={props.personaId}
        isOpen={isOpen}
        onDismiss={dismissPanel}
        onRenderTable={getDataPersonaEquipo}
      />

      <Dialog
        hidden={hideDelteEquipo}
        onDismiss={toggleHideDeleteEquipo}
        dialogContentProps={{
          title: "Eliminar Modelo",
          subText: "¡El registro se eliminará de mandera permanente!",
        }}
      >
        <div style={{ width: "100%" }}>
          <div
            style={{
              width: "42px",
              height: "42px",
              margin: "0 auto",
            }}
          >
            <IdicadorProgress
              isSend={isSendEliminar}
              subText="Enviando Datos"
            />

            <Icon iconName="ShieldAlert" styles={IconStyles} />
          </div>
        </div>
        <DialogFooter>
          <PrimaryButton
            onClick={() => {
              deleteModeloEquipo(
                objEliminarModeleEquipom,
                toggleHideDeleteEquipo
              );
            }}
            text="Eliminar"
          />

          <DefaultButton onClick={toggleHideDeleteEquipo} text="Salir" />
        </DialogFooter>
      </Dialog>
    </>
  );
};
